export default __webpack_public_path__ + "static/media/claimscardiconBackground.3d1cb272.svg";